import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "../../utils/axiosInstance"; 
import { MantineReactTable } from "mantine-react-table";
import { Box, Button, CopyButton, Tooltip, Text } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Swal from "sweetalert2";
import ApproveModal from "./ApproveModal";
import WithdrawAction from "./WithdrawAction";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import { CircularProgress, debounce, makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import CardBody from "components/Card/CardBody";
const useStyles = makeStyles(styles);
const ManageWithdrawal = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [open, setOpen] = useState(false);
  const [paymentId, setPaymentId] = useState("");
  const [userId, setUserId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchData(currentPage, debouncedSearchText);
  }, [currentPage, debouncedSearchText]);

  const fetchData = async (page, debouncedSearchText) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const pageLimit = 10;
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/userExtWalletWithdrReqList?search=${debouncedSearchText}`,
        { page, limit: pageLimit },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*"
          }
        }
      );
      setData(response.data.data);
      setTotalRecords(response.data.data[0]?.totalExternalWallAddCount || 0);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClickAction = (event, PaymentId, UserId) => {
    event.preventDefault();
    setPaymentId(PaymentId);
    setUserId(UserId);
    setOpen(true);
  };

  const columns = [
    { header: "Status", accessorKey: "withdrawData.paymentStatus" },
    {
      header: "Action",
      accessorKey: "action",
      Cell: ({ row }) => {
        const status = row.original.withdrawData.paymentStatus;
        const isDisabled = status === "completed" || status === "Rejected";
    
        return (
          <button
            style={{
              backgroundColor: isDisabled ? "#ccc" : "#228be6",
              cursor: isDisabled ? "not-allowed" : "pointer"
            }}
            className="pay-btn"
            disabled={isDisabled}
            onClick={() => {
              if (!isDisabled) {
                setOpen(true);
                setPaymentId(row.original.withdrawData._id);
                setUserId(row.original.withdrawData.userId);
              }
            }}
          >
            Action
          </button>
        );
      }
    },
    
    { header: "Withdraw Amt", accessorKey: "withdrawData.amount" },
    {
      header: "Remaining Payment",
      accessorKey: "withdrawData.withdrawRemainingAmtPaid"
    },

    {
      header: "Wallet Address",
      accessorKey: "withdrawData.walletAddress",
      Cell: ({ row }) => {
        const address = row.original.withdrawData?.walletAddress;

        return (
          <CopyButton value={address}>
            {({ copy, copied }) => (
              <Tooltip
                label={copied ? "Copied!" : "Click to copy"}
                withArrow
                position="top"
              >
                <Text
                  onClick={copy}
                  size="sm"
                  lineClamp={1}
                  style={{
                    maxWidth: 150,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                  }}
                >
                  {address}
                </Text>
              </Tooltip>
            )}
          </CopyButton>
        );
      }
    },
    { header: "Wallet Network", accessorKey: "withdrawData.walletNetwork" },
    { header: "Crypto-Currency", accessorKey: "withdrawData.cryptoType" },
    { header: "Player Name", accessorKey: "withdrawData.userName" },
    { header: "KYC", accessorKey: "withdrawData.kycStatus" },

    { header: "PaymentId", accessorKey: "withdrawData._id" }
  ];

  const debouncedSearch = useCallback(
    debounce((value) => {
      setDebouncedSearchText(value);
      if (value === "") {
        setCurrentPage(1);
      }
    }, 500),
    []
  );

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Manage withdraw</h4>
              <Box
                sx={{
                  display: "flex",
                  gap: "16px",
                  padding: "16px 5px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%"
  
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "6px 12px",
                    width: "300px",
                    backgroundColor: "#fff",
                  }}
                >
                  <i className="material-icons" style={{ color: "#aaa", marginRight: "8px" }}>
                    search
                  </i>
                  <input
                    type="text"
                    value={searchText}
                    placeholder="Wallet address, name or status"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      debouncedSearch(e.target.value);
                    }}
                    style={{
                      border: "none",
                      outline: "none",
                      width: "100%",
                      fontSize: "14px",
                    }}
                  />
                </Box>
                <Button>
                  Export All Rows
                </Button>
              </Box>
            </CardHeader>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh"
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <CardBody>

                <MantineReactTable
                  columns={columns}
                  data={data}
                  enableColumnFilterModes
                  enablePagination={false}
                  enableFullScreenToggle={false}
                  enableHiding={false}
                  enableDensityToggle={false}
                  enableFilters={false}
                  renderRowActions={({ row }) => (
                    <Box sx={{ display: "flex", gap: "16px" }}>
                      <Tooltip label="Action" withArrow position="left">
                        <Button
                          disabled={
                            row.original.withdrawData.paymentStatus ===
                            "Rejected" ||
                            row.original.withdrawData.paymentStatus ===
                            "Completed"
                          }
                          onClick={(e) =>
                            handleClickAction(
                              e,
                              row.original.withdrawData._id,
                              row.original.withdrawData.userId
                            )
                          }
                          style={{
                            backgroundColor: "#228be6",
                            fontWeight: "bold"
                          }}
                        >
                          Action
                        </Button>
                      </Tooltip>
                    </Box>
                  )}
                  positionActionsColumn="first"

                />
                <WithdrawAction
                  open={open}
                  setOpen={setOpen}
                  paymentId={paymentId}
                  userId={userId}
                  onSuccess={() => fetchData(currentPage, debouncedSearchText)}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px"
                  }}
                >
                  <Pagination
                    pageSize={10}
                    current={currentPage}
                    total={totalRecords}
                    onChange={handlePageChange}
                  />
                </Box>
              </CardBody>
            )}
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
};

export default ManageWithdrawal;
